import { getContrast } from 'polished';

// WCAG 2.1 AA contrast ratio for normal-size text. Above this, white text is
// readable on the given background, so the portal switches to dark mode.
export const WCAG_AA_NORMAL = 4.5;

/**
 * True when the tenant background is dark enough that white text clears WCAG AA
 * (4.5:1). This is the single source of truth for "is the tenant in dark mode".
 * Unset or unparseable colors are treated as light (false) so the app stays in
 * its default light look.
 */
export const isDarkBackground = (color: string | undefined | null): boolean => {
  if (!color) return false;
  try {
    return getContrast('#FFFFFF', color) >= WCAG_AA_NORMAL;
  } catch {
    return false;
  }
};
